var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "score",
      style: "--percentage: " + _vm.currentPercentage + ";",
    },
    [
      _c("div", { staticClass: "score__value" }, [
        _vm._v("\n    " + _vm._s(_vm.currentPercentage) + "%\n  "),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "score__spinner" }, [
        _c(
          "svg",
          {
            attrs: {
              width: "126",
              height: "126",
              viewBox: "0 0 126 126",
              fill: "none",
            },
          },
          [
            _c("circle", {
              attrs: { cx: "63", cy: "63", r: "60", "stroke-width": "6" },
            }),
            _vm._v(" "),
            _c("circle", {
              staticClass: "percent",
              attrs: {
                cx: "63",
                cy: "63",
                r: "60",
                "stroke-width": "6",
                pathLength: "100",
              },
            }),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }